<template>
  <v-dialog
    :value="enableDialog"
    persistent
    width="600"
    @keydown.esc="closeButtonClickEvent"
    @close="closeButtonClickEvent"
  >
    <validation-observer
      ref="observer"
    >
      <v-form>
        <v-card
          v-if="manifestId"
          flat
        >
          <v-toolbar flat>
            <v-toolbar-title>処分事業場の編集</v-toolbar-title>
          </v-toolbar>
          <v-divider />
          <v-card-text>
            <!-- 処分方法 -->
            <v-row>
              <v-col cols="12" md="8">
                <validation-provider
                  v-slot="{ errors }"
                  name="処分方法"
                >
                  <v-select
                    v-model="forms.disposal_method_id"
                    :items="disposalMethods"
                    :error-messages="errors"
                    clearable
                    dense
                    hide-details="auto"
                    label="処分方法"
                    outlined
                    persistent-placeholder
                  ></v-select>
                </validation-provider>
              </v-col>
            </v-row>
          </v-card-text>
          <v-divider />
          <v-card-actions>
            <v-spacer />
            <v-btn
              @click="closeButtonClickEvent"
            >
              閉じる
            </v-btn>
            <v-btn
              color="primary"
              @click="registerButtonClickEvent"
            >
              更新
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </validation-observer>
    <send-mail-confirmable-dialog
      :manifest-id="manifestId"
      :enable-dialog="enableMailConfirmableDialog"
      @negativeCallback="negativeCallback"
      @positiveCallback="positiveCallback"
    />
  </v-dialog>
</template>

<script>
import { mapActions } from 'vuex'
import SendMailConfirmableDialog from '@/driver/pages/manifest/managements/dialogs/_SendMailConfirmableDialog.vue'

export default {
  name: 'EditDisposerLocationDialog',
  components: {
    SendMailConfirmableDialog,
  },
  mixins: [],
  props: {
    enableDialog: {
      type: Boolean,
      default: () => false,
    },
    manifestId: {
      type: Number,
      default: () => null,
    },
    disposalMethods: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      enableMailConfirmableDialog: false,
      forms: {
        disposal_method_id: null
      }
    }
  },
  computed: {},
  watch: {
    enableDialog (newVal) {
      this.$nextTick(() => this.$refs.observer.reset())
      Object.assign(this.$data.forms, this.$options.data().forms)
      if (newVal) {
        this.setVariable()
      }
    },
  },
  created() {
  },
  methods: {
    ...mapActions('DriverManifestManagementDisposerLocation', {
      fetchCollectionReport: 'edit',
      updateCollectionReport: 'update',
    }),
    ...mapActions("DriverManifestManagementVerifyDisposerLocation", {
      verifyCollectionLocation: "update",
    }),
    setVariable () {
      this.fetchCollectionReport({ id: this.manifestId }).then((content) => {
        this.forms = content
      })
    },
    closeButtonClickEvent () {
      this.$emit('closeCallback')
    },
    negativeCallback () {
      this.enableMailConfirmableDialog = false;
    },
    positiveCallback () {
      this.updateManifest()
    },
    registerButtonClickEvent () {
      let $self = this
      this.$refs.observer.validate().then((result) => {
        if(result) {
          $self.sendRegistrationInformation()
        }
      })
    },
    sendRegistrationInformation () {
      let params = this.buildParams();
      this.verifyCollectionLocation({ id: this.manifestId, params: params }).then((content) => {
        if (content.changed) {
          this.enableMailConfirmableDialog = true;
        } else {
          this.updateManifest(params);
        }
      })
    },
    updateManifest () {
      let params = this.buildParams()
      this.updateCollectionReport({ id: this.manifestId, params: params }).then(() => {
        this.enableMailConfirmableDialog = false;
        this.$emit('registerCallback')
      })
    },
    buildParams () {
      let params = {
        disposal_method_id: this.forms.disposal_method_id,
      }
      return params;
    },
  }
}
</script>

<style scoped lang="scss">

</style>
